module.exports = __webpack_public_path__ + "img/07_3_2_1.993e2d14.png";